module.exports = __webpack_public_path__ + "static/img/line.789b844e.png";